import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
// .. Link root api
const API_ROOT_URL = environment.ApiRoot + '/dashboard';
// ................
@Injectable()
export class DashboardInventoryNormsService {
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(productTypes: number[] = [], products: number[] = []): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = API_ROOT_URL + `/DashBoardInventoryNorms`;
		let params = new HttpParams();
		productTypes.forEach(type => {
		  	params = params.append('productTypes', type.toString());
		});
		products.forEach(type => {
			params = params.append('products', type.toString());
		});
		return this.http.get<any>(url,
		{
			headers: httpHeaders,
			params: params
		});
	}

	exportDashboardInventoryNorms(
			productTypes: number[] = [],
			products: number[] = [],
			productCode: string,
			productName: string,
			unitName: string
		) : Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		let params = new HttpParams();
		productTypes.forEach(type => {params = params.append('productTypes', type.toString());});
		products.forEach(type => {params = params.append('products', type.toString());});
		params = params.append('productCode', productCode.toString());
		params = params.append('productName', productName.toString());
		params = params.append('unitName', unitName.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/export_dashboard_inventory_norms', {
		  headers: httpHeaders,
		  params: params,
		  responseType: 'blob' as 'json'
		});
	}
}
